import { IFunctionState } from './types';

const initialFunctionState = (): IFunctionState => ({
  loading: false,
});

export default initialFunctionState;
